export enum DigitalConfirmation {
	IBRO = 'ibro_checkbox',
	ORDERS = 'sms_in_orders',
}

